<template lang="pug">
	.chart-scale(:style="{ height: height + '%' }")
		.label {{ leftLabel }}
		.drawLines(v-for="i in range" :style="{ height: (100/ ( range.length + 1 )) + '%' }" :key="i")
			.drawScale {{ formatNumberReal(i) }}
</template>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
	.label {
		color: #555;
		float: right;
		margin-right: 2vw;
	}
	.chart-scale {
		position: absolute;
		left: 0;
		background: transparent;
		scrollbar-width: none;
		width: 100%;
		&::-webkit-scrollbar {
			display: none;
		}
		.one {
			height: 100%;
		}
	}
	.drawLines {
		border-bottom: 1px dashed green;
		color: red;
		text-align: right;
		margin-right: 2%;
		text-align: bottom;
		position: relative;
	}

	.drawScale {
		font-family: $font-sans-serif;
		font-weight: 700;
		color: #5a726a;
		font-size: 2vmin;
		position: absolute;
		bottom: 0;
		right: 0;
	}

</style>

<script>
import formatNumberReal from '@/lib/utils/formatNumberReal';

export default {
	name       : 'chartScale',
	components : {	 },
	props : {
		leftLabel: {
			type: String,
		},
		height: {
			type: Number,
		},
		range: {
			type     : Array,
			required : true,
		},
	},
	data : () => ( {

	} ),
	computed : {

	},

	methods : {
		formatNumberReal(num) {
			return formatNumberReal(num);
		},
	},
	created() {
		// console.log(`created chartScale ${this.height}`);
		// console.log(this.range);
		// console.log(`div height: ${this.height} / (${this.range.length} + 1)} =  ${(this.height / (this.range.length +1))}`);
	},

	mounted() {
	},

	watch : {
	},

};
</script>
